Vue.component('ack-resins-title', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-resins-title',
	mounted() {
		appLog.log('ack-resins-title mounted');
	},
	props: {
		productInfo: {
			// :product-info
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('shop', [
			'currentCurrency',
			'currentCurrencySymbol',
			'currentCountryCode',
			'isStoreAvailable',
		]),
		...Vuex.mapGetters('localization', [
			'countryCode',
			'isUS_CA',
			'redirectLinkWhenHideStore',
			'isIreland',
			'isTW',
		]),
		productIsNotAvailableInRegion() {
			let notAvailable = false;
			if (
				this.currentCountryCode.toUpperCase() == 'US' ||
				this.currentCountryCode.toUpperCase() == 'CA'
			) {
				notAvailable = true;
			}
			return notAvailable;
		},
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
	},
	beforeDestroy() {},
	watch: {
		data: {
			handler() {},
			deep: false,
		},
	},
});
